import { DriftClientMetricsEvents } from '@drift-labs/sdk';

// Event handler types
export type EmitterHandler<T> = (data: T) => void;
export type DriftClientTxSignedHandler = EmitterHandler<
	DriftClientMetricsEvents['txSigned']
>;

// TX metrics options
export type TxMetricsOpts = {
	measurePreSignTimeMetricKey?: string;
	measurePreSignTime?: boolean;
};

// Storage for previous tx handler
export const PREVIOUS_TX_SIGNED_HANDLER: {
	current: DriftClientTxSignedHandler | undefined;
} = {
	current: undefined,
};
